/**
 * R14-SH6 (QA R14_QA_studio_2 group 13): is the creative AdSense says it FILLED actually on screen?
 *
 * `data-ad-status="filled"` is AdSense's verdict on the `<ins>`; it says nothing about the box. A filled unit
 * can still show nothing: the creative iframe collapsed to 0 x 0 by AdSense's own responsive rules (a), the
 * unit's container hidden by our layout at this width (`d-none d-lg-block` rails under 992 px) (b). The close
 * key belongs to a creative the user can see, so it needs BOTH the verdict and a rendered box -- the `<ins>`,
 * its container and the creative iframe all non-zero, none of them under a `hidden` ancestor.
 *
 * Where the document reports no layout at all (jsdom) the verdict alone decides, the `slotInDocument` rule
 * (`ad-slot.util.ts`); the boxes are checked wherever they exist.
 */
export function creativeIsVisible(ins: Element | null | undefined): boolean {
    if (!ins || !ins.isConnected) return false;
    if (ins.closest('[hidden]')) return false;
    if (typeof document === 'undefined' || !document.body) return false;
    if (document.body.getClientRects().length === 0) return true;
    if (!hasBox(ins) || !hasBox(ins.parentElement)) return false;
    const frame = ins.querySelector('iframe');
    return !!frame && hasBox(frame);
}

/** A rendered box: non-zero width AND height (a `display: none` ancestor gives 0 x 0). */
export function hasBox(el: Element | null | undefined): boolean {
    if (!el) return false;
    const b = el.getBoundingClientRect();
    return b.width > 0 && b.height > 0;
}
